var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg34512673Ce61B0Db299F7E2405Ac60E9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82798 11.963H8.78398C8.78398 11.963 9.07298 11.931 9.22098 11.775C9.35698 11.63 9.35298 11.361 9.35298 11.361C9.35298 11.361 9.33398 10.096 9.92998 9.90795C10.516 9.72495 11.27 11.132 12.069 11.673C12.674 12.081 13.133 11.992 13.133 11.992L15.27 11.963C15.27 11.963 16.387 11.895 15.858 11.027C15.815 10.959 15.549 10.388 14.268 9.21395C12.928 7.98895 13.108 8.18695 14.723 6.06695C15.705 4.77495 16.098 3.98595 15.975 3.64895C15.858 3.32695 15.135 3.41195 15.135 3.41195L12.729 3.42695C12.729 3.42695 12.551 3.40395 12.418 3.48095C12.289 3.55695 12.207 3.73495 12.207 3.73495C12.207 3.73495 11.826 4.73495 11.318 5.58595C10.246 7.37895 9.81798 7.47395 9.64198 7.36195C9.23498 7.10195 9.33698 6.31895 9.33698 5.76195C9.33698 4.02395 9.60398 3.29895 8.81598 3.11095C8.55498 3.04995 8.36198 3.00895 7.69398 3.00195C6.83498 2.99395 6.10898 3.00395 5.69698 3.20395C5.42398 3.33595 5.21198 3.62995 5.34098 3.64695C5.49998 3.66795 5.85998 3.74295 6.05098 3.99895C6.29798 4.32995 6.28898 5.07195 6.28898 5.07195C6.28898 5.07195 6.43098 7.11895 5.95798 7.37295C5.63298 7.54695 5.18798 7.19095 4.23298 5.56395C3.74498 4.72995 3.37498 3.80895 3.37498 3.80895C3.37498 3.80895 3.30398 3.63695 3.17698 3.54495C3.02298 3.43295 2.80798 3.39695 2.80798 3.39695L0.520979 3.41195C0.520979 3.41195 0.177979 3.42095 0.0519791 3.56895C-0.0600209 3.69995 0.0429791 3.96995 0.0429791 3.96995C0.0429791 3.96995 1.83298 8.09996 3.85898 10.18C5.71798 12.089 7.82798 11.963 7.82798 11.963Z",
    fill: "#F6F6F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg34512673Ce61B0Db299F7E2405Ac60E9);
export default __webpack_public_path__ + "static/media/34512673ce61b0db299f7e2405ac60e9.af566de6905cc5cff8bd638c2ac086bc.svg";
export { ForwardRef as ReactComponent };